// This is a bridge between the nice observable properties from app.config and the older JS code that communicates with the API.
export const apiConfig = {
	accessToken:     "",
	authFailHandler: () => {},
	urls:            { // URLs should include trailing slash, e.g. "http://localhost:10050/v1/"
		pn_api:          "",
		pn_comments_api: "",
		pn_files_api:    "",
		pn_auth_ws:      ""
	},
	client:  "", // e.g. "ext"
	version: ""  // e.g. "0.73.0"
};
